module.exports = __webpack_public_path__ + "img/vps_picture3.95a810c.png";